import {getCurrentInstance} from "vue";

export const useStickyScroll = () => {
  const self = getCurrentInstance().proxy;

  document.onscroll = function(_e) {
    self.position = document.documentElement.scrollTop || document.body.scrollTop;
  }
}
